// Lightweight client-side SEO: sets document title, meta description, Open Graph, and JSON-LD.
function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data == null) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

const DEFAULT_TITLE = "LIVENEAT Organic | Live Better. Eat Better. Choose Organic.";

export function setSeo({ title, description, image, jsonLd } = {}) {
  document.title = title ? `${title} | LIVENEAT Organic` : DEFAULT_TITLE;
  upsertMeta("name", "description", description);
  upsertMeta("property", "og:title", title || DEFAULT_TITLE);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:url", window.location.href);
  if (image) {
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:image", image);
  }
  let canon = document.head.querySelector('link[rel="canonical"]');
  if (!canon) { canon = document.createElement("link"); canon.rel = "canonical"; document.head.appendChild(canon); }
  canon.href = window.location.href.split("?")[0];
  setJsonLd("ld-page", jsonLd || null);
}

export function resetSeo() {
  setSeo({});
  setJsonLd("ld-page", null);
}
